// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Ml-z","tupacHeader":"Nl-z","tupacHeader2":"Ol-z","tupacMenu":"Pl-z","tupacMenu2":"Ql-z","tupacMain":"Rl-z","tupacMain2":"Sl-z"};